import Cookies from 'js-cookie'
import { useCallback } from 'react'

import { getExternalTokenCookieName } from '../config/authCookies'

export const useZervantNavigation = () => {
  const externalTokenCookieName = getExternalTokenCookieName()
  const externalToken = Cookies.get(externalTokenCookieName)
  const baseZervantRootUrl = window.ENV?.ZERVANT_NAVIGATION_URL || '' // for Storybook fallback to empty string
  const zervantRootUrl = `${baseZervantRootUrl}/login/login?zervant-return-access=${externalToken}`

  const redirectToZervantDashboard = useCallback(() => {
    window.location.href = zervantRootUrl
  }, [zervantRootUrl])

  const redirectToZervantInvoicesView = useCallback(() => {
    window.location.href = `${zervantRootUrl}&view=invoices`
  }, [zervantRootUrl])

  const redirectToZervantInvoiceView = useCallback(
    (invoiceId: string) => {
      window.location.href = `${zervantRootUrl}&view=invoice&invoiceId=${invoiceId}`
    },
    [zervantRootUrl],
  )

  const redirectToZervantAccountPlanView = useCallback(() => {
    window.location.href = `${zervantRootUrl}&view=accountPlan`
  }, [zervantRootUrl])

  return {
    redirectToZervantAccountPlanView,
    redirectToZervantDashboard,
    redirectToZervantInvoicesView,
    redirectToZervantInvoiceView,
  }
}
